import React from 'react';
/* eslint-disable import/no-anonymous-default-export */
import { BaseText, NumeralIndex, CountryName } from './components';

export const getGciLabel = (value) => {
	let textValue = 'Least favorable';
	if (value >= 48) textValue = 'Less favorable';
	if (value >= 54) textValue = 'Favorable';
	if (value >= 62) textValue = 'Most favorable';
	return <div className="font-bold">{textValue}</div>;
};
export default [
	NumeralIndex({
		Header: () => (
			<div className="desktop-only --inline  text-mono text-mono--grey">
				Investment <br />
				index
			</div>
		),
		title: 'Investment index',
		accessor: 'invest_rank',
	}),
	CountryName(),
	BaseText({
		HeaderName: 'Score',
		accessor: 'invest_points',
		maxWidth: 56,
		HeaderTooltip: `The Investment Index (worth 25% of the Global Passport Index score) is based on Markets Innovation (weighted at 50% of the Investment Index score), Gross National Income Per Capita, and Personal Income (weighted at 25% each).`,
	}),

	BaseText({
		Header: (
			<div className="desktop-only --inline  text-mono text-mono--grey">
				Markets & Innovation
			</div>
		),
		accessor: 'gci_pillars_points',
		Cell: ({ value }) => getGciLabel(value),
		minWidth: 240,
		desktopOnly: true,
		title: 'Markets & Innovation',
	}),
	BaseText({
		HeaderName: 'GNI per capita',
		accessor: 'gni_pc_value',
		minWidth: 180,
		desktopOnly: true,
		Cell: ({ value }) => {
			const formattedValue = new Intl.NumberFormat('de-DE').format(value);
			const result = value ? `$${formattedValue}` : '-';
			return <div className="font-bold">{result}</div>;
		},
	}),
	BaseText({
		Header: (
			<div className="desktop-only --inline  text-mono text-mono--grey">
				Personal Taxation
			</div>
		),
		accessor: 'tax_value',
		maxWidth: 120,
		desktopOnly: true,
		title: 'Personal Taxation',
		Cell: ({ value }) => {
			return <div className="font-bold">{value}%</div>;
		},
	}),
];
